export const WebServicesRoutes = [
  {
    path: "integrations/web-services",
    component: () => import("@/domain/Integrations/WebServices/presentation/pages/WebServicesLayout.vue"),
    meta: { requiresAuth: true, permissions: "integrations.read" },
    children: [
      {
        path: "",
        name: "listWebServices",
        component: () => import("@/domain/Integrations/WebServices/presentation/pages/ListWebServicesPage.vue"),
        meta: { requiresAuth: true, permissions: "integrations.read" },
      },
      {
        path: "new",
        name: "newWebService",
        component: () => import("@/domain/Integrations/WebServices/presentation/pages/NewWebServicePage.vue"),
        meta: { requiresAuth: true, permissions: "integrations.write" },
      },
      {
        path: ":id",
        name: "editWebService",
        component: () => import("@/domain/Integrations/WebServices/presentation/pages/EditWebServicePage.vue"),
        meta: { requiresAuth: true },
      },
    ],
  },
];
